module.exports = __webpack_public_path__ + "img/81.7.Chla.a503c07b.png";